import type { Route } from '@angular/router';

import { inject } from '@angular/core';
import { defaultRouteGuard } from '@core/guards/default-route/default-route.guard';
import { loggedGuard } from '@core/guards/logged.guard';
import { mustHaveRoleGuard } from '@core/guards/must-have-role/must-have-role.guard';
import { sortLifeMomentsByLabel } from '@domains/life-moments/utils';
import { FEATURES_ROUTING } from '@features/routes';
import { RoleEnum } from '@models/commons/role';
import { LifeMomentsWebservice } from '@webservices/life-moments/life-moments.webservice';
import { map } from 'rxjs';

const GUARDS = [loggedGuard, mustHaveRoleGuard, defaultRouteGuard];
export const FEATURES_ROUTES: Route[] = [
  {
    path: FEATURES_ROUTING.Partners,
    loadChildren: async () => (await import('@features/partners/routes/partners.routes')).PARTNERS_ROUTES,
    canActivate: GUARDS,
    data: {
      role: RoleEnum.ROLE_CONFIGURATOR_LOYALTY,
    },
  },
  {
    path: FEATURES_ROUTING.Services,
    canActivate: GUARDS,
    data: {
      role: RoleEnum.ROLE_SERVICES_LOYALTY,
    },
    loadChildren: async () => (await import('@features/services/routes')).SERVICES_ROUTES,
  },
  {
    path: FEATURES_ROUTING.Users,
    canActivate: GUARDS,
    data: {
      role: RoleEnum.ROLE_SUPPORT_LOYALTY,
    },
    loadChildren: async () => (await import('@features/users/routes/users.routes')).USERS_ROUTES,
  },
  {
    path: FEATURES_ROUTING.LifeMoments,
    canActivate: GUARDS,
    data: {
      role: RoleEnum.ROLE_CONFIGURATOR_LOYALTY,
    },
    title: 'Liste des moments de vie',
    loadComponent: async () => (await import('@features/life-moments/life-moments.component')).LifeMomentsComponent,
    resolve: {
      lifeMoments: () => inject(LifeMomentsWebservice).getLifeMomentsList().pipe(map(sortLifeMomentsByLabel)),
    },
  },
  {
    path: FEATURES_ROUTING.CRM,
    canActivate: GUARDS,
    data: {
      role: RoleEnum.ROLE_CRM_LOYALTY,
    },
    loadChildren: async () => (await import('@features/crm/routes/crm.routes')).CRM_ROUTES,
  },
  {
    path: FEATURES_ROUTING.DevTools,
    loadChildren: async () => (await import('@features/dev-tools/routes')).DEV_TOOLS_ROUTES,
    canActivate: GUARDS,
    data: {
      role: RoleEnum.ROLE_CONFIGURATOR_LOYALTY,
    },
  },
  { path: '', redirectTo: 'partners', pathMatch: 'full' },
];
